"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FrontPageLayout = void 0;
const react_1 = __importDefault(require("react"));
const classFunctions_1 = require("../../../../utils/classFunctions");
const Footer_1 = require("../Footer");
const Header_1 = require("../Header");
require("./index.scss");
const className = 'front-page';
class FrontPageLayout extends react_1.default.PureComponent {
    render() {
        const { modificators, ...restProps } = this.props;
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement("div", { className: `${className}__header` },
                    react_1.default.createElement(Header_1.FrontPageHeader, { ...restProps })),
                react_1.default.createElement("div", { className: `${className}__body` },
                    react_1.default.createElement("div", { className: `${className}__content` }, this.props.children)),
                react_1.default.createElement("div", { className: `${className}__footer` },
                    react_1.default.createElement(Footer_1.FrontPageFooter, null)))));
    }
}
exports.FrontPageLayout = FrontPageLayout;
//# sourceMappingURL=index.js.map